import React from 'react';
import { MarkdownContent } from 'ha/ui.legacy/Markdown/MarkdownContent';
import { H2, H3 } from 'ha/ui.legacy/Headers';
import { MarkdownP } from 'ha/ui.legacy/Markdown/MarkdownP';
import { MarkdownImage } from 'ha/ui.legacy/Markdown/MarkdownImage';
import { BlogShareToSocialNetworksContainer as BlogShareToSocialNetworks } from '../containers/BlogShareToSocialNetworks';
import { BlogLandingBlockquote } from './BlogLandingBlockquote';
import { LandingBlogData } from '../types';

interface Props {
  data: LandingBlogData;
}

interface MarkdownComponentProps {
  children: React.ReactNode;
}
interface MarkdownImageProps {
  title: string;
  src: string;
  className: string;
}

const BlogContent: React.FC<Props> = ({ data }) => (
  <MarkdownContent
    content={data.content}
    components={{
      h1: ({ children }: MarkdownComponentProps) => (
        <div className="m-y-3">
          <H2 className="m-b-1_5 color-black font-size-xxlg">{children}</H2>
          <div className="blog-landing--line line-green m-b-2" />
          <BlogShareToSocialNetworks kind="defaultGrey" title="" />
        </div>
      ),
      h2: ({ children }: MarkdownComponentProps) => (
        <div className="m-y-3">
          <H2 className="m-b-1_5 color-black font-size-xxlg">{children}</H2>
          <div className="blog-landing--line line-green" />
        </div>
      ),
      h3: ({ children }: MarkdownComponentProps) => (
        <H3 className="color-mint m-t-3 m-b-2">{children}</H3>
      ),
      strong: ({ children }: MarkdownComponentProps) => (
        <strong className="color-brand">{children}</strong>
      ),
      p: ({ children }: MarkdownComponentProps) => (
        <MarkdownP className="line-height-twice">{children}</MarkdownP>
      ),
      img: (props: MarkdownImageProps) => (
        <MarkdownImage {...props} quality={90} />
      ),
      blockquote: BlogLandingBlockquote,
    }}
  />
);

export { BlogContent };
